/* tslint:disable */
/* eslint-disable */
/**
 * STRY API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface BeginPaymentRequest
 */
export interface BeginPaymentRequest {
    /**
     * 
     * @type {number}
     * @memberof BeginPaymentRequest
     */
    organizationId: number;
    /**
     * URL to send user to when payment is complete
     * @type {string}
     * @memberof BeginPaymentRequest
     */
    successUrl: string;
    /**
     * URL to send user to when payment is cancelled
     * @type {string}
     * @memberof BeginPaymentRequest
     */
    cancelUrl: string;
}

export function BeginPaymentRequestFromJSON(json: any): BeginPaymentRequest {
    return BeginPaymentRequestFromJSONTyped(json, false);
}

export function BeginPaymentRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): BeginPaymentRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'organizationId': json['organization-id'],
        'successUrl': json['success-url'],
        'cancelUrl': json['cancel-url'],
    };
}

export function BeginPaymentRequestToJSON(value?: BeginPaymentRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'organization-id': value.organizationId,
        'success-url': value.successUrl,
        'cancel-url': value.cancelUrl,
    };
}


